import { useState, useRef, useEffect } from 'react';
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import { useNavigate } from 'react-router-dom';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import WriteDiscoverMapPopup from "@/pages/comp/edu/discover_map/popup/write";
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import CalendarArea from "./area/calendar";

function DiscoverMapListCalendar() {
  const FindStudentListRef = useRef<any>(null);
  const CalendarAreaRef = useRef<any>(null);
  const right_cal_ref = useRef<any>(null);
  const navigate = useNavigate();
  const is_discover_select_ing = useRef<boolean>(false);
  const [discover_list_opt, set_discover_list_opt] = useState<any>({
    select_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_addon_discover_map_start_date: "",
    s_addon_discover_map_end_date: "",
  });
  const [stu_list_opt, set_stu_list_opt] = useState<any>({
    ...discover_list_opt,
    s_addon_discover_map: "1",
  });

  let default_popup_data_opt = {
    isOpen: false,
    sort: "write_discover_map",//write_discover_map

    stu_seq: "",
    row_data: {},
    is_update: false,

    title: "팝업",
    width: "500px",
    height: "70%",
  };
  const [popupData, setPopupData] = useState<any>({
    ...default_popup_data_opt
  });

  useEffect(() => {
    if (FindStudentListRef.current) {
      set_stu_list_opt(FindStudentListRef.current.getListOpt());
    }
  }, []);

  const go_write_page = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      ...inData
    };
    if (CalendarAreaRef.current && opt_obj.stu_seq) {
      let select_stu_seq_arr: any = [opt_obj.stu_seq];
      CalendarAreaRef.current.setInitData({
        stu_seq_arr: select_stu_seq_arr,
        ...opt_obj
      });
    }
  };

  const go_delete_by_ajax = (inData: any) => {
    let opt_obj = {
      discover_map: {},
      ...inData
    };
    is_discover_select_ing.current = true;
    setTimeout(() => {
      is_discover_select_ing.current = false;
    }, 200);
    let discover_map = opt_obj.discover_map;
    if (strFunc.is_empty(discover_map.a_seq)) {
      alert("삭제할 정보가 없습니다.");
      return false;
    }

    if (!confirm("디스커버리맵 한개를 삭제 하시겠습니까?")) {
      return false;
    }

    let from_json_data: any = {
      data_arr: [discover_map],
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/delete', from_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("삭제 되었습니다.");
          FindStudentListRef.current.list({});
          go_write_page({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_write_discover_map = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      row_data: {},
      is_update: false,
      ...inData
    };
    setPopupData({
      ...default_popup_data_opt,
      isOpen: true,
      sort: "write_discover_map",
      title: "디스커버리 맵",

      stu_seq: opt_obj.stu_seq,
      row_data: opt_obj.row_data,
      is_update: opt_obj.is_update,

      width: "95%",
      height: "90%",
    });
  };

  return (
    <div>
      <SearchArea
        listOpt={stu_list_opt}
        setListOpt={(inData: any) => {
          if (FindStudentListRef.current) {
            FindStudentListRef.current.setListOpt(inData);
            set_stu_list_opt(inData);
          }
        }}
        list={(inData: any) => {
          if (FindStudentListRef.current) {
            FindStudentListRef.current.list(inData);
            set_stu_list_opt({
              ...stu_list_opt,
              ...inData
            });
          }
        }}
        search_line_right_text={(
          <button className="btn-m btn-dark"
            onClick={() => {
              navigate("/comp/edu/discover_map/list");
            }}
          >디커맵</button>
        )}
      ></SearchArea>
      <table>
        <colgroup>
          <col width={"20%"}></col>
          <col width={"*"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "410px" }}>
                <div className="mt-1">
                  <FindStudentList
                    ref={FindStudentListRef}
                    listOpt={stu_list_opt}
                    grid_opt={{
                      is_idx_num: false,
                      is_add_checkbox: false,
                      floatingFilter: false,
                      rowMultiSelectWithClick: true,
                      rowSelection: "single",
                    }}
                    show_key_arr={["row_view_discover_map"]}
                    list={(inData: any) => {
                      if (inData.s_stu_user_seq && inData.s_stu_user_seq.length > 0) {
                        go_write_page({
                          stu_seq: inData.s_stu_user_seq[0],
                        });
                      }
                    }}
                    is_show_search_area={false}
                    discover_select={(inData: any) => {
                      let opt_obj = {
                        stu_info: {},
                        discover_map: {},
                        discover_map_arr: [],
                        ...inData
                      };
                      // go_write_page({
                      //   stu_seq: opt_obj["stu_info"]["a_seq"],
                      // });
                      open_write_discover_map({
                        stu_seq: opt_obj["stu_info"]["a_seq"],
                        row_data: opt_obj["discover_map"],
                      });
                    }}
                    discover_delete={go_delete_by_ajax}
                  ></FindStudentList>
                </div>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "720px" }}>
                <div ref={right_cal_ref}>
                  <CalendarArea
                    ref={CalendarAreaRef}
                    select_date={discover_list_opt.select_date}
                    set_select_date={(inData: any) => {
                      let s_start_date = DateFunc.get_date_format(new Date(inData), "Y-m-01");
                      let s_end_date = DateFunc.get_date_format(new Date(inData), "Y-m-t");
                      set_discover_list_opt({
                        ...discover_list_opt,
                        select_date: inData,
                        s_addon_discover_map_start_date: s_start_date,
                        s_addon_discover_map_end_date: s_end_date
                      });
                      FindStudentListRef.current.list({
                        "s_addon_discover_map_start_date": s_start_date,
                        "s_addon_discover_map_end_date": s_end_date
                      });
                    }}
                    list={(inData: any) => {
                      FindStudentListRef.current.list(inData);
                    }}
                    open_write_discover_map={open_write_discover_map}
                  ></CalendarArea>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <RightScrollFix right_ref={right_cal_ref} limit_scroll_top={300} ></RightScrollFix>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "write_discover_map" &&
            <WriteDiscoverMapPopup
              stu_seq={popupData.stu_seq}
              row_data={popupData.row_data}
              is_update={popupData.is_update}
              list={() => {
                FindStudentListRef.current.list({});
                // go_write_page({
                //   stu_seq: "",
                // });
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></WriteDiscoverMapPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default DiscoverMapListCalendar;